export type ColumnAggregationMode = 'none' | 'sum' | 'average' | 'both';

export const COLUMN_AGGREGATION_LABELS: Record<ColumnAggregationMode, string> = {
  none: 'Ninguno',
  sum: 'Suma',
  average: 'Promedio',
  both: 'Suma y promedio',
};

export const DEFAULT_COLUMNS = ['To-do', 'En proceso', 'En revisión', 'Bloqueado', 'Hecho'] as const;

export const PRIORITIES = ['low', 'medium', 'high', 'urgent'] as const;
export type ProjectPriority = (typeof PRIORITIES)[number];

export const PRIORITY_LABELS: Record<ProjectPriority, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  urgent: 'Urgente',
};

export const PRIORITY_COLORS: Record<ProjectPriority, string> = {
  low: '#94a3b8',
  medium: '#3b82f6',
  high: '#f59e0b',
  urgent: '#ef4444',
};

export const PROJECT_STATUSES = ['active', 'paused', 'archived'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  active: 'Activo',
  paused: 'Pausado',
  archived: 'Archivado',
};

export const PROJECT_COLORS = [
  '#6366f1', '#8b5cf6', '#ec4899', '#ef4444', '#f97316',
  '#eab308', '#22c55e', '#14b8a6', '#06b6d4', '#64748b',
] as const;

export type ProjectView = 'board' | 'calendar' | 'timeline' | 'list';

export const VIEW_LABELS: Record<ProjectView, string> = {
  board: 'Board',
  calendar: 'Calendario',
  timeline: 'Timeline',
  list: 'Lista',
};

export const COLUMN_BG_PRESETS = [
  '', '#e0e7ff', '#dbeafe', '#d1fae5', '#fef3c7', '#fce7f3', '#fee2e2', '#f3f4f6',
] as const;

export const STICKY_NOTE_COLORS = [
  '#fef08a', '#fbcfe8', '#bbf7d0', '#bfdbfe', '#fde68a', '#e9d5ff', '#fed7aa', '#fecaca',
] as const;

export const DEFAULT_STICKY_NOTE_COLOR = STICKY_NOTE_COLORS[0];

export type CalendarMode = 'month' | 'week' | 'day';
export type TimelineMode = 'week' | 'month' | 'quarter';

export const STATUS_DONE = [
  'Hecho', 'Done',
  'Completada', 'Completado', 'Completadas', 'Completados', 'Completo',
  'Terminada', 'Terminado', 'Terminadas', 'Terminados',
  'Lista', 'Listas', 'Listo',
];
export const STATUS_BLOCKED = ['Bloqueado', 'Bloqueada', 'Blocked'];
export const STATUS_REVIEW = ['En revisión', 'Review'];
export const STATUS_IN_PROGRESS = ['En proceso', 'En progreso', 'In progress'];

export function isTaskDone(status: string, completed?: boolean): boolean {
  if (completed) return true;
  return STATUS_DONE.some(s => s.toLowerCase() === status.toLowerCase());
}

export function isTaskBlocked(status: string): boolean {
  return STATUS_BLOCKED.some(s => s.toLowerCase() === status.toLowerCase());
}
